import React from 'react';

import Tooltip from 'components/ui-components/tooltip';

import './styles.less';

export default ({ onClick }) => (
  <div className="trash-button" onClick={onClick}>
    <Tooltip>Delete video</Tooltip>
  </div>
);
